import draw_polygon from '../draw_polygon'
import * as algorithm from './lib/algorithm/index'
import * as Constants from '../../constants';
import doubleClickZoom from '../../lib/double_click_zoom'
import createVertex from '../../lib/create_vertex';

const DrawPolygonShape = { ...draw_polygon }

DrawPolygonShape.onSetup = function () {
    const polygon = this.newFeature({
        type: Constants.geojsonTypes.FEATURE,
        properties: {
            name: this.name,
            isCustom: true,
            type: this.type,
            coordinates: [],
            'fill-color': '#54A6F2',
            'line-color': '#54A6F2',
            opacity: 0.1,
            visible: true,
            description: "",
            'properties-dictionary': [
                { key: 'name', label: '名称', type: 'string' },
                { key: 'fill-color', label: '填充色', type: 'color' },
                { key: 'line-color', label: '边框色', type: 'color' },
                { key: 'opacity', label: '透明度', type: 'number', step: 0.1, min: 0, max: 1 },
                { key: 'description', label: '说明', type: 'textArea' }
            ]
        },
        geometry: {
            type: Constants.geojsonTypes.POLYGON,
            coordinates: []
        }
    });

    this.addFeature(polygon);

    this.clearSelectedFeatures();
    doubleClickZoom.disable(this);
    this.updateUIClasses({ mouse: Constants.cursors.ADD });
    this.activateUIButton(Constants.types.POLYGON);
    this.setActionableState({
        trash: true
    });

    return {
        polygon,
        algorithmName: this.algorithmName,
        fixedPointCount: this.fixedPointCount,
        currentVertexPosition: 0,
    };
}

DrawPolygonShape.clickAnywhere = function (state, e) {
    state.currentVertexPosition++;
    state.polygon.properties.coordinates.push([e.lngLat.lng, e.lngLat.lat]);
    state.polygon.setCoordinates(algorithm[state.algorithmName](state.polygon.properties.coordinates));
    if (state.currentVertexPosition >= state.fixedPointCount) {
        // 结束绘制
        this.changeMode(Constants.modes.SIMPLE_SELECT, { featureIds: [state.polygon.id] }, { silent: false });
    }
}

DrawPolygonShape.onMouseMove = function (state, e) {
    if (state.currentVertexPosition > 0) {
        state.polygon.setCoordinates(algorithm[state.algorithmName]([].concat(state.polygon.properties.coordinates, [[e.lngLat.lng, e.lngLat.lat]])))
    }
}

DrawPolygonShape.toDisplayFeatures = function (state, geojson, display) {
    const isActivePolygon = geojson.properties.id === state.polygon.id;
    geojson.properties.active = (isActivePolygon) ? Constants.activeStates.ACTIVE : Constants.activeStates.INACTIVE;
    if (!isActivePolygon) return display(geojson);
    if (geojson.geometry.coordinates.length === 0) return;

    if (state.fixedPointCount > 2 && geojson.geometry.coordinates[0].length < 4) {
        const lineCoordinates = geojson.geometry.coordinates[0].slice(0, 2);
        display({
            type: Constants.geojsonTypes.FEATURE,
            properties: geojson.properties,
            geometry: {
                coordinates: lineCoordinates,
                type: Constants.geojsonTypes.LINE_STRING
            }
        });
    }

    geojson.properties.user_coordinates.forEach((coordinate, index) => {
        display(createVertex(state.polygon.id, coordinate, `0.${index}`, false));
    })

    // render the Polygon
    return display(geojson);
}

DrawPolygonShape.onStop = function (state) {
    this.updateUIClasses({ mouse: Constants.cursors.NONE });
    doubleClickZoom.enable(this);
    this.activateUIButton();

    // check to see if we've deleted this feature
    if (this.getFeature(state.polygon.id) === undefined) return;
    //remove last added coordinate
    //state.polygon.removeCoordinate(`0.${state.currentVertexPosition}`);
    if (state.polygon.isValid()) {
        this.map.fire(Constants.events.CREATE, {
            features: [state.polygon.toGeoJSON(true)]
        });
    } else {
        this.deleteFeature([state.polygon.id], { silent: true });
        this.changeMode(Constants.modes.SIMPLE_SELECT, {}, { silent: true });
    }
};

// export default DrawPolygonShape;

/**
 * 多个点的polygon图形，双击结束
 * @param {*} opts 
 * @param {String} opts.type 类型 用draw_${type}调用
 * @param {String} opts.name 名字 用于编辑面板上展示
 * @param {Number} opts.fixedPointCount 骨骼点数量
 * @returns 
 */
const polygonShapeFractory = function (opts) {
    const target = { ...DrawPolygonShape }
    target.name = opts.name
    target.type = opts.type
    target.algorithmName = `${opts.type}_algorithm`
    target.fixedPointCount = opts.fixedPointCount
    return target
}

export default polygonShapeFractory;